<template lang="pug">
  .b-base-user-field
    ._label(v-if="labelOuter && label") {{ label }}
    button._control(
      type="button"
      :class="{ error: !!error, disabled: disabled }"
      :disabled="disabled"
      @click="selectUser"
      )
      UserTile._user(v-if="selected" :user="selected" :size="30")
      span._placeholder(v-else) {{ placeholder }}
      Icon._icon(name="arrow" pointer)
    ._error-text(v-if="error") {{ error }}
</template>

<script>
import popupModel from '@/model/popup';

import UserTile from '@/components/UserTile.vue';
import UserSelectPopup2 from '@/components/UserSelectPopup2.vue';

/**
 * Поле выбора пользователя для универсальных форм (тип поля `user`).
 *
 * Своего списка пользователей не знает: кого можно выбрать, решает форма и
 * передаёт в options. Наружу отдаёт IRI выбранного пользователя, как и
 * остальные поля-ссылки, а объект для отрисовки берёт из того же options.
 */
export default {
  name: 'BaseUserField',
  components: { UserTile },
  props: {
    // IRI выбранного пользователя
    value: {
      type: String,
      default: null,
    },
    // пользователи, из которых можно выбирать
    options: {
      type: Array,
      default: () => [],
    },
    label: String,
    labelOuter: Boolean,
    error: String,
    disabled: Boolean,
    // объявлен, чтобы не осесть в $attrs и не вылезти атрибутом в разметку
    type: String,
    emptyLabel: {
      type: String,
      default: 'Нет доступных пользователей',
    },
  },
  computed: {
    selected() {
      return this.options.find(user => user['@id'] === this.value) ?? null;
    },
    placeholder() {
      return this.labelOuter ? 'Не выбрано' : this.label;
    },
  },
  methods: {
    async selectUser() {
      if (this.disabled) return;

      // UserSelectPopup2 сам себе попап: открывается через popupModel с
      // позиционными аргументами (selected, multiple, customUserSet, ...)
      const user = await popupModel.add({
        component: UserSelectPopup2,
        args: [[], false, this.options, this.label, this.emptyLabel],
      });
      if (!user) return;

      this.$emit('input', user['@id']);
    },
  },
};
</script>

<style scoped lang="scss">
.base-user-field {
  // повторяет размеры и палитру BaseInput, чтобы поле не выбивалось из формы
  &__label {
    display: block;
    font-size: 13px;
    color: #92A0B0;
    margin-bottom: 8px;
  }

  &__control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    min-height: 39px;
    box-sizing: border-box;
    padding: 4px 16px;
    border: 1px solid transparent;
    border-radius: 6px;
    background: var(--color-super-light);
    text-align: left;
    cursor: pointer;

    &.error {
      border-color: var(--color-red);
    }

    &.disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  &__placeholder {
    font-size: 13px;
    font-weight: 500;
    color: var(--color-middle-gray);
  }

  &__icon {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
    color: var(--color-middle-gray);
  }

  &__error-text {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    color: var(--color-red);
  }
}
</style>
